import { LedgerStatement } from "@/pages/Ledger";

export default function ARLedger() {
  return (
    <LedgerStatement
      ptype="ar"
      title="AR Ledger"
      subtitle="Customer statement of account — invoices, receipts and running balance for a period"
      partyLabel="Customer"
      testPrefix="ar-ledger"
    />
  );
}
